import { render, staticRenderFns } from "./OrganizationChart.vue?vue&type=template&id=05830e2e&scoped=true&"
import script from "./OrganizationChart.vue?vue&type=script&lang=js&"
export * from "./OrganizationChart.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationChart.vue?vue&type=style&index=0&id=05830e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05830e2e",
  null
  
)

export default component.exports